import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../elements/Box';
import { StyledProps } from '@front10';

interface Props {
  /**
   * Translation key
   */
  labelKey: string;
  /**
   * Data test ID of Disclaimer
   */
  dataTestId: string;
  /**
   * Custom Content
   */
  content: string;
  id?: string;
}

function Disclaimer(props: StyledProps<Props>) {
  const { labelKey, dataTestId, content, id } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  const contentToRender =
    content ||
    translate(labelKey, 'Disclaimer including text and <a href="#">Terms & Conditions</a>');

  return (
    <Box className={`${className} fr-disclaimer`} style={style} dataTestId={dataTestId} id={id}>
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: contentToRender
        }}
      />
    </Box>
  );
}

Disclaimer.defaultProps = {
  labelKey: 'cmp-module-disclaimer',
  dataTestId: 'disclaimer',
  content: null
};

Disclaimer.componentName = 'Disclaimer';

export default Disclaimer;
